import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../music24/components/primitives/SMLButton';
import { CatalogItem } from '../../../redux/api/fymAPI.types';
import { releaseListMessages } from '../../music24/promote/releases/list/releaseListMessages';
import { useDraftFinishSetupPath } from '../../music24/promote/releases/list/useDraftFinishSetupPath';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from './Catalog.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * "Finish setup" on the Catalog row of a draft song (design catalog-add-song h4, owner answer 1):
 * it opens the next step of the "Add a song" page, and Close comes back to the Catalog. The same
 * rule as the Releases list (`useDraftFinishSetupPath`): only a draft gets it, and never in the
 * native web view. Renders nothing for any other song.
 */
const CatalogFinishSetupComponent: React.FC<{ item: CatalogItem }> = ({ item }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const path = useDraftFinishSetupPath(item, 'catalog');
  const open = useCallback(() => {
    if (path !== null) {
      // eslint-disable-next-line no-void -- a router navigation: nothing to wait for
      void navigate(path);
    }
  }, [navigate, path]);

  if (path === null) {
    return null;
  }
  return (
    <span className={styles.rowCell}>
      <SMLButton
        onClick={open}
        className={styles.smallButton}
        ariaLabel={intl.formatMessage(releaseListMessages.finishSetupLabel, { title: item.title })}
      >
        {intl.formatMessage(releaseListMessages.finishSetup)}
      </SMLButton>
    </span>
  );
};

export const CatalogFinishSetup = TypedMemo(CatalogFinishSetupComponent);
